/* Splits snack price tags ($X each · N for $Y) into two stacking lines on mobile. Loaded by the locations section. */
(function(){
  function split(){
    var tags=document.querySelectorAll('.spz-price-tag');
    Array.prototype.forEach.call(tags,function(t){
      if(t.querySelector('.spz-pt-a'))return;
      var txt=(t.textContent||'');
      var idx=txt.indexOf(' · ');
      if(idx<0)return;
      var a=txt.slice(0,idx).trim();
      var b=txt.slice(idx+3).trim();
      t.innerHTML='<span class="spz-pt-a">'+a+'</span><span class="spz-pt-b">'+b+'</span>';
    });
  }
  if(document.readyState!=='loading'){split();}else{document.addEventListener('DOMContentLoaded',split);}
})();
